// extracted by mini-css-extract-plugin
module.exports = {"Initials":"initials_Initials__3km5L"};